import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


export const getVisiblePages = (
  currentPage: number,
  totalPages: number,
  maxVisible = 5
) => {
  const half = Math.floor(maxVisible / 2);

  let start = Math.max(1, currentPage - half);
  let end = Math.min(totalPages, start + maxVisible - 1);

  // Adjust start if we're near the end
  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1);
  }

  return { start, end };
};

export const charLimitMessage = (max: number) =>
  `Character limit exceeded. Maximum ${max} characters allowed.`;
